import { useContext } from 'react';
import PerformanceMonitorTrackSelfContext from '../../internal/provider/PerformanceMonitorTrackSelfContext';
export default function usePerformanceMonitorTrack() {
    return useContext(PerformanceMonitorTrackSelfContext);
}

//# sourceMappingURL=usePerformanceMonitorTrack.js.map